import { render } from "./BusinessHoursCreate.vue?vue&type=template&id=005a135d"
import script from "./BusinessHoursCreate.vue?vue&type=script&lang=js"
export * from "./BusinessHoursCreate.vue?vue&type=script&lang=js"

import "./BusinessHoursCreate.vue?vue&type=style&index=0&id=005a135d&lang=css"

import exportComponent from "/Users/borchekostovski/Documents/Projects/CreativeLabs/Projects/Ching-a-ling/ching-a-ling-cms-menu/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__